import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AddRowAfter = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.50006 13.5C7.50006 13.7761 7.72392 14 8.00006 14C8.2762 14 8.50006 13.7761 8.50006 13.5L8.50006 11L11.0001 11C11.2762 11 11.5001 10.7761 11.5001 10.5C11.5001 10.2239 11.2762 10 11.0001 10L8.50006 10L8.50006 7.5C8.50006 7.22386 8.2762 7 8.00006 7C7.72392 7 7.50006 7.22386 7.50006 7.5L7.50006 10L5.00006 10C4.72392 10 4.50006 10.2239 4.50006 10.5C4.50006 10.7761 4.72392 11 5.00006 11L7.50006 11L7.50006 13.5ZM11.5 4.5L13.5 4.5L13.5 2.5L11.5 2.5L11.5 4.5ZM11.5 5.5L10.5 5.5L8.5 5.5L7.5 5.5L5.5 5.5L4.5 5.5L2.5 5.5C1.94772 5.5 1.5 5.05228 1.5 4.5L1.5 2.5C1.5 1.94771 1.94772 1.5 2.5 1.5L4.5 1.5L5.5 1.5L7.5 1.5L8.5 1.5L10.5 1.5L11.5 1.5L13.5 1.5C14.0523 1.5 14.5 1.94772 14.5 2.5L14.5 4.5C14.5 5.05229 14.0523 5.5 13.5 5.5L11.5 5.5ZM4.5 2.5L2.5 2.5L2.5 4.5L4.5 4.5L4.5 2.5ZM5.5 4.5L5.5 2.5L7.5 2.5L7.5 4.5L5.5 4.5ZM10.5 4.5L8.5 4.5L8.5 2.5L10.5 2.5L10.5 4.5Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default AddRowAfter
